import { ReactNode } from 'react'
import BaseDialog from '../BaseDialog'

export interface ConfirmationDialogProps {
  onConfirm: () => void
  onCancel: () => void
  open: boolean
  title: string
  description: string
  confirmLabel: string
  cancelLabel?: string
  children?: ReactNode
}

const ConfirmationDialog = ({
  onConfirm,
  onCancel,
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  children,
}: ConfirmationDialogProps) => {
  return (
    <BaseDialog
      title={title}
      description={description}
      open={open}
      onClose={onCancel}
      onSubmit={onConfirm}
      width={600}
      submitLabel={confirmLabel}
      cancelLabel={cancelLabel}
    >
      {children}
    </BaseDialog>
  )
}

export default ConfirmationDialog
